import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../styles/styles-css-variables";
import { SwarovskiButton } from "../_shared-components/ui-elements/SwarovskiButton";
import React from "react";
import { fontColor, FONTS, fontSize } from "../../styles/fonts";
import { ExpandedRichText, Link } from "@swo/shared";
import { SORichTextRenderer } from "../_shared-components/so-rich-text";

export const IconsAndTextsItem: ReactTFC<{
  headline: React.ReactNode;
  icon: { url: string; title: string | undefined } | React.JSX.Element;
  text?: ExpandedRichText;
  ctaButton?: Link;
}> = props => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;

        > img,
        svg {
          height: 61px;
          margin-bottom: 30px;
        }
      `}
    >
      {"url" in props.icon ? (
        <img src={props.icon.url} title={props.icon.title} alt={props.icon.title} />
      ) : (
        <>{props.icon}</>
      )}
      <span
        css={[
          FONTS.SwarovskiFutura500,
          fontSize.x2,
          css`
            display: block;

            color: ${CSS_COLORS.Black};
            text-transform: uppercase;
            margin-top: 0;
            margin-bottom: 0;
          `,
        ]}
      >
        {props.headline}
      </span>
      {props.text && (
        <div
          css={[
            FONTS.SwarovskiFutura300,
            fontColor.black,
            fontSize.x2,
            css`
              line-height: 24px;

              p {
                word-break: break-word;
              }
              a {
                color: var(--so-green);
              }
            `,
          ]}
        >
          <SORichTextRenderer richText={props.text} options={"default"} />
        </div>
      )}

      {props.ctaButton && (
        <div
          css={css`
            margin-top: 15px;
          `}
        >
          <SwarovskiButton
            as={"a"}
            isInternal={props.ctaButton.type === "Internal Link"}
            link={props.ctaButton.data}
            variant={"plain-underline"}
            target={!!props.ctaButton.openInNewTab ? "_blank" : undefined}
            rel={!!props.ctaButton.openInNewTab ? "noopener noreferrer" : undefined}
          >
            {props.ctaButton.label}
          </SwarovskiButton>
        </div>
      )}
    </div>
  );
};
